import {
  SEARCH_TYPE_ROUTER,
  SEARCH_COUNTRY_TYPE_ROUTER,
} from '@/utils/static-router-alias.js'

export default {
  methods: {
    handleLoading(event) {
      const values = [].concat(
        Object.values(SEARCH_TYPE_ROUTER.alias.en),
        Object.values(SEARCH_TYPE_ROUTER.alias.es),
        Object.values(SEARCH_COUNTRY_TYPE_ROUTER.alias.en),
        Object.values(SEARCH_COUNTRY_TYPE_ROUTER.alias.es),
        'search'
      )

      let pathname =
        event.target.localName.toLowerCase() === 'a'
          ? event.target.pathname
          : ''

      if (pathname === '') {
        pathname = event.target.closest('a').href
      }

      pathname = pathname.replace(process.env.APP_URL, '')

      if (
        this.$route.path !== pathname &&
        values.some((t) => pathname.startsWith(`/${t}`))
      ) {
        this.$nuxt.$emit('custom-loading', { enabled: true, source: 'search' })
      }
    },
  },
}
